import ContractorsResource from "./contractors.resource";

const contractorsModule = angular
  .module("app.resources.contractors", [])
  .service("Contractors", ContractorsResource);

export default contractorsModule;



// WEBPACK FOOTER //
// ./src/resources/contractors/contractors.module.js